/* eslint-disable no-underscore-dangle */
import L from 'leaflet';

const HEIGHT = 58;
const WIDTH = 34;
const CONTAINER_STYLE = `
  cursor: pointer;
  height: ${HEIGHT}px;
  width: ${WIDTH}px;
`;
const SVG_IN_SRC = '/maps-buttons/+.svg';
const SVG_OUT_SRC = '/maps-buttons/-.svg';
const SVG_IN_STYLE = `
  width:100%;
  height:${(WIDTH / HEIGHT) * 100}%;
  position: absolute;
  top: 0px;
  left: 0px;
`;
const SVG_OUT_STYLE = `
  width:100%;
  height:${(WIDTH / HEIGHT) * 100}%;
  position: absolute;
  top: 24px;
  left: 0px;
  z-index: -1;
`;
const SVG_IN_TITLE = 'Zoom in';
const SVG_OUT_TITLE = 'Zoom out';

L.Control.CustomZoom = L.Control.Zoom.extend({
  onAdd(map) {
    // eslint-disable-next-line no-param-reassign
    map.customZoomButton = this;
    const container = L.DomUtil.create('div');
    container.style.cssText = CONTAINER_STYLE;

    this._zoomInButton = this._createButton(
      SVG_IN_SRC,
      SVG_IN_STYLE,
      SVG_IN_TITLE,
      container,
      this._zoomIn
    );
    this._zoomOutButton = this._createButton(
      SVG_OUT_SRC,
      SVG_OUT_STYLE,
      SVG_OUT_TITLE,
      container,
      this._zoomOut
    );

    this._updateDisabled();
    map.on('zoomend zoomlevelschange', this._updateDisabled, this);

    return container;
  },

  _createButton(src, style, title, container, fn) {
    const link = L.DomUtil.create('img', '', container);
    link.src = src;
    link.title = title;
    link.style = style;

    L.DomEvent.disableClickPropagation(link);
    L.DomEvent.on(link, 'click', L.DomEvent.stop);
    L.DomEvent.on(link, 'click', fn, this);
    L.DomEvent.on(link, 'click', this._refocusOnMap, this);

    return link;
  }
});

L.control.customzoom = opts => new L.Control.CustomZoom(opts);

/**
 * Adds the custom zoom in the leaflet map after the map is loaded.
 *
 * @param {object} leafletMap - The leaflet map.
 */
const customZoom = leafletMap => {
  L.control.customzoom().addTo(leafletMap);
};

export default customZoom;
